import { render } from "./UsersClinicalHealthSystems.vue?vue&type=template&id=ec8efe1a&scoped=true&lang=pug"
import script from "./UsersClinicalHealthSystems.vue?vue&type=script&lang=js"
export * from "./UsersClinicalHealthSystems.vue?vue&type=script&lang=js"

import "./UsersClinicalHealthSystems.vue?vue&type=style&index=0&id=ec8efe1a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec8efe1a"]])

export default __exports__